import { render } from "./card-project-featured.vue?vue&type=template&id=4adae040&scoped=true"
import script from "./card-project-featured.vue?vue&type=script&lang=js"
export * from "./card-project-featured.vue?vue&type=script&lang=js"

import "./card-project-featured.vue?vue&type=style&index=0&id=4adae040&lang=scss&scoped=true"

import exportComponent from "/home/mark/Dev/www/Portfolio/portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4adae040"]])

export default __exports__